import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpModule, JsonpModule } from '@angular/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// Services
import { DataService } from './services/data.service';
import { SecurityService } from './services/security.service';
import { ConfigurationService } from './services/configuration.service';
import { StorageService } from './services/storage.service';
import { ValidatorService } from './services/validator.service';
import { JwtModuleOptions, JwtModule } from '@auth0/angular-jwt';
import { AuthGuardService } from './services/auth-guard.service';
import { AuthService } from './services/auth.service';
import { RoleGuardService } from './services/role-guard.service';
import { SignalRService } from './services/signalr.service';
import { DocumentService } from './services/document.service';
// Components:
// Pipes:
const JwtModuleOptions: JwtModuleOptions = {
  config: {
      tokenGetter: Array[''],
      whitelistedDomains: Array['login']
  }
};
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    JwtModule.forRoot(JwtModuleOptions),
    // No need to export as these modules don't expose any components/directive etc'
    HttpModule,
    JsonpModule
  ],
  declarations: [
  ],
  exports: [
    // Modules
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    // Providers, Components, directive, pipes
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [
        // Providers
        DataService,
        SecurityService,
        ConfigurationService,
        StorageService,
        ValidatorService, AuthGuardService, AuthService, RoleGuardService, SignalRService, DocumentService
      ]
    };
  }
}
